(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["del-dia-explainer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ctpx-dd-intro').forEach(function (root) {
    var track = root.querySelector('.ctpx-dd-intro__tiles--mobile-carousel');
    var dots = root.querySelectorAll('.ctpx-dd-intro__dot');
    if (!track || !dots.length) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var max = track.scrollWidth - track.clientWidth;
        var index = max > 0 ? Math.round((track.scrollLeft / max) * (dots.length - 1)) : 0;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
        ticking = false;
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["del-dia-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ctpx-dd-tabs').forEach(function (root) {
    root.querySelectorAll('.ctpx-dd-tabs__link').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-ctpx-tab');
        root.querySelectorAll('.ctpx-dd-tabs__link').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        root.querySelectorAll('.ctpx-dd-tabs__panel').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-ctpx-panel') === key);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* CTPX utility link mega menu — hover/focus open, click still navigates */
  (function () {
    document.querySelectorAll('[data-ctpx-utility]').forEach(function (root) {
      var link = root.querySelector('.ctpx-utility-link');
      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        root.classList.add('is-open');
        if (link) link.setAttribute('aria-expanded', 'true');
      }

      function close() {
        closeTimer = setTimeout(function () {
          root.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
        }, 120);
      }

      root.addEventListener('mouseenter', open);
      root.addEventListener('mouseleave', close);
      root.addEventListener('focusin', open);
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          root.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
        }
      });
    });
  })();

  /* CTPX inline predictive search — Shopify suggest API */
  (function () {
    document.querySelectorAll('[data-ctpx-search]').forEach(function (root) {
      var input = root.querySelector('.ctpx-inline-search__input');
      var clear = root.querySelector('.ctpx-inline-search__clear');
      var results = root.querySelector('.ctpx-inline-search__results');
      if (!input || !results) return;

      var timer;
      var lastQuery = '';

      function hide() {
        results.hidden = true;
        results.innerHTML = '';
      }

      function render(q, queries, products) {
        var html = '';
        queries.slice(0, 6).forEach(function (s) {
          html += '<a href="/search?q=' + encodeURIComponent(s.text) + '">' + s.styled_text + '</a>';
        });
        if (!queries.length) {
          products.slice(0, 6).forEach(function (p) {
            html += '<a href="' + p.url + '">' + p.title + '</a>';
          });
        }
        if (html) {
          html += '<a class="ctpx-inline-search__all" href="/search?q=' + encodeURIComponent(q) + '">'
            + 'Search for &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo;</a>';
          results.innerHTML = html;
          results.hidden = false;
        } else {
          hide();
        }
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clear.hidden = q.length === 0;
        clearTimeout(timer);
        if (q.length < 2) {
          hide();
          return;
        }
        timer = setTimeout(function () {
          lastQuery = q;
          fetch(
            '/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=query,product&resources[limit]=6&resources[options][unavailable_products]=hide'
          )
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (q !== lastQuery) return;
              var res = (data.resources && data.resources.results) || {};
              render(q, res.queries || [], res.products || []);
            })
            .catch(hide);
        }, 220);
      });

      clear.addEventListener('click', function () {
        input.value = '';
        clear.hidden = true;
        hide();
        input.focus();
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') hide();
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) hide();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    function isVisible(el) {
      return el.getClientRects().length > 0;
    }

    // first VISIBLE gallery image — Horizon renders separate markup for the
    // desktop grid and mobile carousel, so the first img in the DOM may be
    // inside a container that's display:none at this viewport
    function findVisibleImg(media) {
      var imgs = media.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (isVisible(imgs[i]) && imgs[i].getBoundingClientRect().width > 40) {
          return imgs[i];
        }
      }
      return null;
    }

    // keep exactly one note element, no matter how often the gallery re-renders
    function dedupe(media) {
      var notes = media.querySelectorAll('.ctpx-model-note');
      for (var i = 1; i < notes.length; i++) notes[i].remove();
      return notes[0] || null;
    }

    // climb from the image to the largest wrapper that still contains ONLY
    // this image — its own cell, never a container spanning the whole gallery
    function cellFor(img, media) {
      var el = img;
      while (
        el.parentElement &&
        el.parentElement !== media &&
        el.parentElement.querySelectorAll('img').length === 1
      ) {
        el = el.parentElement;
      }
      return el === img ? img.parentElement : el;
    }

    function tryPlace(media) {
      var note = dedupe(media);
      if (!note) return true;
      if (note.dataset.placed && isVisible(note)) return true;
      var img = findVisibleImg(media);
      if (!img) return false;
      var cell = cellFor(img, media);
      if (!cell || cell === media) return false;
      if (getComputedStyle(cell).position === 'static') {
        cell.style.position = 'relative';
      }
      cell.appendChild(note);
      note.dataset.placed = 'true';
      note.classList.add('ctpx-model-note--placed');
      return true;
    }

    function init() {
      document.querySelectorAll('.product-information__media').forEach(function (media) {
        if (!media.querySelector('.ctpx-model-note')) return;

        tryPlace(media);
        // stay watching: the gallery renders late AND re-renders on variant
        // change (which restores the note at the root) — re-place each time.
        // tryPlace is a no-op when the note is already placed and visible.
        new MutationObserver(function () {
          tryPlace(media);
        }).observe(media, { childList: true, subtree: true });

        // crossing the mobile/desktop breakpoint hides the container the note
        // sits in — move it to the newly visible first image
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            var note = media.querySelector('.ctpx-model-note') || document.querySelector('.ctpx-model-note');
            if (note && !isVisible(note)) {
              note.dataset.placed = '';
              tryPlace(media);
            }
          }, 200);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
